/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { Input, Table, Button, Tag, Tooltip, Dropdown, Space, message, Popconfirm } from 'antd';
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import moment from 'moment';
import UilPen from '@iconscout/react-unicons/icons/uil-pen';
import UilLock from '@iconscout/react-unicons/icons/uil-lock-alt';
import UilUnLock from '@iconscout/react-unicons/icons/uil-unlock-alt';
import { ExportCsv, ExportPdf } from '@material-table/exporters';
import { DownloadOutlined, DownOutlined } from '@ant-design/icons';

import FormDialog from './FormDialog';
import { TableWrapper } from '../../../container/styled';
import { BtnWithIcon, Main } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { DataService } from '../../../config/dataService/dataService';
import './form.css'
import { CompSelector } from '../../common';
import { themeColor } from '../../../config/theme/themeVariables';


function DataTable() {
  const [tableData, setTableData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [search, setSearch] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [showForm, setShowForm] = useState(false);
  const [editID, setEditID] = useState(null);
  const [compID, setCompID] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(false);

  const fetchTableData = async () => {
    try {
      setBusy(true)
      const response = await DataService.post('/comp-fps/query', {
        page: currentPage,
        pageSize,
        search,
        comp_id: compID
      });
      const { data, total } = response.data;
      setTableData(data);
      setTotalRows(total);
      setBusy(false)
    } catch (error) {
      message.error(`Error fetching table data:  ${error.message}`)
      setBusy(false)
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleExportCsv = () => {
    const formattedData = tableData.map((item) => ({
      ...item,
      reg_date: moment(item.created_at).format('DD-MM-YYYY'),
    }));

    const tCols = [];

    TableColumns.forEach(item => { if (item.export) tCols.push(item) })
    ExportCsv(tCols, formattedData, `Company FPs${moment().format('DD-MM-YYYY')}`);
  };

  const handleExportPdf = () => {
    const formattedData = tableData.map((item) => ({
      ...item,
      reg_date: moment(item.created_at).format('DD-MM-YYYY'),
    }));

    const tCols = [];
    TableColumns.forEach(item => { if (item.export) tCols.push(item) })
    ExportPdf(tCols, formattedData, `Company FPs_${moment().format('DD-MM-YYYY')}`);
  };

  useEffect(() => {
    fetchTableData();
    if (reload) setReload(false)
  }, [currentPage, pageSize, search, reload]);

  const exportMenuItems = [
    {
      label: 'Export CSV',
      key: 1,
      icon: <DownloadOutlined />,
    },
    {
      label: 'Export PDF',
      key: 2,
      icon: <DownloadOutlined />,
    },
  ];

  const handleExportMenuClick = (event) => {
    let { key } = event;
    key = Number(key)
    if (key === 1) {
      handleExportCsv();
    } else if (key === 2) {
      handleExportPdf();
    }
  };

  const exportMenuProps = {
    items: exportMenuItems,
    onClick: handleExportMenuClick,
  };

  const handleEditRowClck = (event) => {
    const { currentTarget } = event;
    const dataID = Number(currentTarget.getAttribute('data-index') || 0)
    setEditID(dataID)
    setShowForm(true)
  }

  useEffect(() => {
    fetchTableData();
  }, [compID])

  const handleDeleteRowClck = async (event) => {
    try {
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)
      const dbRec = tableData.find(item => item.id === dataID);
      if (dbRec) {
        setBusy(true)
        const response = await DataService.post('/comp-fps/delete', {
          id: dataID,
          status: !Boolean(dbRec.status)
        });

        const { status } = response.data;
        if (status) {
          setReload(true)
          message.success(response.data.message)
        } else {
          message.error(response.data.message)
        }
        setBusy(false)
      }
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const TableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      field: 'name',
      export: true,
    },
    {
      title: 'CNIC',
      dataIndex: 'cnic',
      key: 'cnic',
      field: 'cnic',
      export: true,
    },
    {
      title: 'Designation',
      dataIndex: 'designation',
      key: 'designation',
      field: 'designation',
      export: true,
    },
    {
      title: 'Contact #',
      dataIndex: 'contact',
      key: 'contact',
      field: 'contact',
      export: true,
      // onCell: () => ({
      //   style: { textAlign: 'center' },
      // }),
    },
    {
      title: 'Company',
      dataIndex: 'comp_name',
      key: 'comp_name',
      field: 'comp_name',
      export: true,
      // onCell: () => ({
      //   style: { textAlign: 'center' },
      // }),
    },
    {
      title: 'Record Status',
      dataIndex: 'status',
      key: 'status',
      field: 'status',
      export: true,
      // onHeader: () => { },
      onHeader: () => ({
        style: { textAlign: 'center' },
      }),
      render: (is_active) => {
        let color = themeColor['danger-color']
        let lblStr = 'InActive';

        if (Boolean(is_active)) {
          lblStr = 'Active'
          color = themeColor['success-color']
        }

        return (
          <div className="flex justify-content-center">
            <div className='taglist-wrap select-none'>
              <Tag color={color}>{lblStr}</Tag>
            </div>
          </div>
        )
      },
    },
    {
      title: 'Actions',
      export: false,
      width: 10,
      render: (rowData) => {
        // console.log('rowData', rowData)
        return (<div className='flex flex-row justify-between select-none'>
          <Tooltip title='Edit Record' className='select-none'>
            <BtnWithIcon
              onClick={handleEditRowClck}
              data-index={rowData.id}
            >
              <UilPen
                className='hover:scale-110 hover:text-blue-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                size={20}
              />
            </BtnWithIcon>
          </Tooltip>
          <Tooltip title={`${rowData.status ? 'Block' : 'Unblock'} record`} className='select-none'>
            <Popconfirm
              title={`Are you sure to ${rowData.status ? 'block' : 'unblock'} this record ?`}
              onConfirm={handleDeleteRowClck}
              okButtonProps={{
                'data-index': rowData.id
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <BtnWithIcon className='ninjadash-delete'>
                {rowData.status ?
                  <UilLock
                    className='ninjadash-delete hover:scale-110 hover:text-red-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                    size={20}
                  />
                  :
                  <UilUnLock
                    className='ninjadash-delete hover:scale-110 hover:text-green-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                    size={20}
                  />
                }
              </BtnWithIcon>
            </Popconfirm>
          </Tooltip>
        </div >
        )
      },
    },
  ];

  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Company Focal Persons" routes={[]} />
      <Main>
        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <Input
              className=" hover:drop-shadow-xl hover:border-solid hover:border-1 hover:border-blue-800 rounded-sm w-1/4"
              size='small'
              autoFocus
              placeholder="Search Anything"
              prefix={<UilSearch size={15} />}
              defaultValue={search}
              onChange={(e) => handleSearch(e.target.value)}
            />


            <div className="flex space-x-2">
              <div className="min-w-60">
                <CompSelector onItemSelected={setCompID} placeholder='Filter By Company' defaultSize='small' />
              </div>
              <Dropdown className="min-w-40" menu={exportMenuProps}>
                <Button className='h-9'>
                  <Space>
                    Export Data
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
              <Button type="primary" onClick={(event) => {
                setShowForm(true)
              }}>
                Add New
              </Button>
              {/* <FontAwesome icon="fa-sharp fa-solid fa-file-pdf" /> */}

            </div>
          </div>
          <div className="ninjadasj-datatable">
            <TableWrapper >
              <Table
                rowKey={(record) => `${record.id}`} // Generate a unique key for each row
                loading={busy}
                key={`${currentPage}-${pageSize}`} // Add a unique key to force re-render
                bordered
                virutal
                size='middle'
                className='border rounded drop-shadow-sm'
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalRows,
                  showSizeChanger: true,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
                dataSource={tableData}
                columns={TableColumns}
                scroll={{ x: 'max-content' }} // Ensure table has a fixed scroll behavior
              />
            </TableWrapper>
          </div>
        </div>
        {showForm && <FormDialog showDialog={() => { setShowForm(false); setEditID(null) }} setReload={setReload} editId={editID || null} isEdit={editID || false} />}
      </Main>
    </>
  );
}

export default DataTable;
